// Domready

$(function () {
  appendMoveMultipleTextfieldsEvents();

  $(
    '.input__wrapper[data-input-type="multiple-textfields"] .input__add-input-link'
  ).on('click', function () {
    var wrapper = $(this).parents('.input__wrapper');
    var scaffold = wrapper
      .find('.input__scaffold > .multiple-textfields__container')
      .clone();
    scaffold.find('.input__textfield').attr('data-form-value', '');
    scaffold
      .find('.multiple-textfields__button')
      .removeAttr('data-move-event-added');
    scaffold
      .find('.multiple-textfields__button')
      .removeAttr('data-remove-event-added');
    scaffold.appendTo(wrapper.find('.multiple-textfields__wrapper'));
    appendMoveMultipleTextfieldsEvents();
  });
});

// Append move and delete functions

function appendMoveMultipleTextfieldsEvents() {
  $('.multiple-textfields__button--move:not([data-move-event-added])').each(
    function (index, item) {
      $(item).on('click', function () {
        moveContainer(
          '.multiple-textfields__container',
          $(this),
          $(this).hasClass('multiple-textfields__button--up') ? 'up' : 'down'
        );
      });

      $(item).attr('data-move-event-added', '');
    }
  );

  $('.multiple-textfields__button--remove:not([data-remove-event-added])').each(
    function (index, item) {
      $(item).on('click', function () {
        $(this).parents('.multiple-textfields__container').remove();
      });

      $(item).attr('data-remove-event-added', '');
    }
  );
}
